import React from 'react';
import { Box, Typography } from '@mui/material';

const text = value => typeof value === 'string' || typeof value === 'number' ? String(value).trim() : '';
export const delivery99Address = (order = {}) => ({
  ...order.delivery?.deliveryAddress,
  ...order.customer?.addressInfo,
  ...(Number(order.deliveryType) === 2 ? order.additionalInfo?.deliveryAddressOverride?.address : {}),
});

export default function NinetyNineFoodCustomerDelivery({ order = {}, driver }) {
  const customer = order.customer || {};
  const address = delivery99Address(order);
  const phone = text(customer.providerVirtualPhone) || text(customer.phoneNumber)
    || text(customer.phone?.number) || text(customer.phone) || text(customer.whatsapp);
  const type = Number(order.deliveryType ?? order.ninetyNineFood?.deliveryType);
  const street = text(address.streetName || address.street);
  const number = text(address.streetNumber || address.number);
  const formatted = text(address.formattedAddress) || [street, number].filter(Boolean).join(', ') || text(customer.address);
  return <>
    {order.merchant?.name && <Box mt={2}>
      <Typography variant="h6" gutterBottom>Restaurante</Typography>
      <Typography variant="body2">Nome: {order.merchant.name}</Typography>
    </Box>}
    <Box mt={2}>
      <Typography variant="h6" gutterBottom>Cliente</Typography>
      <Typography variant="body2">Nome: {text(customer.name) || 'Não informado'}</Typography>
      <Typography variant="body2">CPF: {text(customer.cpf) || 'Não informado'}</Typography>
      <Typography variant="body2"><Box component="span" sx={{ fontWeight: 700 }}>Telefone:</Box> {phone || 'Não informado pela 99Food'}</Typography>
      <Typography variant="body2"><Box component="span" sx={{ fontWeight: 700 }}>Localizador:</Box> {text(customer.providerLocator) || 'Não informado'}</Typography>
    </Box>
    {order.fulfillment === 'delivery' && <Box mt={2}>
      <Typography variant="h6" gutterBottom>Entrega</Typography>
      <Typography variant="body2">Modalidade: {type === 2 ? 'Entrega própria da loja' : 'Entrega 99Food'}</Typography>
      <Box mt={1}>
        <Typography variant="subtitle2">Endereço de Entrega:</Typography>
        <Typography variant="body2">{formatted || 'Não informado pela 99Food'}</Typography>
        <Typography variant="body2">Bairro: {text(address.neighborhood) || 'Não informado'}</Typography>
        <Typography variant="body2">CEP: {text(address.postalCode || address.cep) || 'Não informado'}</Typography>
        <Typography variant="body2">Cidade: {text(address.city) || 'Não informado'}</Typography>
        <Typography variant="body2">Estado: {text(address.state) || 'Não informado'}</Typography>
        <Typography variant="body2">Complemento: {text(address.complement) || 'Não informado'}</Typography>
        <Typography variant="body2">Referência: {text(address.reference) || 'Não informado'}</Typography>
      </Box>
      {driver?.name && <Typography variant="body2">Entregador: {driver.name}</Typography>}
      {driver?.phone && <Typography variant="body2">Telefone do entregador: {driver.phone}</Typography>}
    </Box>}
  </>;
}
